import { render, staticRenderFns } from "./Tally.vue?vue&type=template&id=8a93a150&"
import script from "./Tally.vue?vue&type=script&lang=js&"
export * from "./Tally.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports